import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";


class IrvYerTanimlariListeAPI extends BaseAPI {


  constructor() {
    const baseUrl = environment.API_URL + "IrvYerTanimlariListe";
    super(baseUrl);
  }


  geIrvYerTanimlariListeListe(yerKodu?: number, mahalleKodu?: number, caddeSokakKodu?: number) {
    return this.get("", { params: { yerKodu: yerKodu, mahalleKodu: mahalleKodu, caddeSokakKodu: caddeSokakKodu } })

  }

}
export default new IrvYerTanimlariListeAPI();
class IrvYerTanimlariListeListeRequest {
  public yerKodu?: number;
  public mahalleKodu?: number;
  public caddeSokakKodu?: number;
  constructor(yerKodu?: number, mahalleKodu?: number, caddeSokakKodu?: number) {

    this.caddeSokakKodu = caddeSokakKodu;
    this.mahalleKodu = mahalleKodu;
    this.yerKodu = yerKodu;

  }
}
export { IrvYerTanimlariListeListeRequest };